import React, { Component } from "react";
import { GridRow, GridColumn } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { Anchor } from "arv-extends";
import FooterLinkItem from "./FooterLinkItem";

const CustomAnchor = Anchor.component;

class FooterLinks extends Component {
  constructor() {
    super();
    this.getSectionClass = this.getSectionClass.bind(this);
  }
  getSectionClass(index) {
    const { data } = this.props;
    const dataLength = (data && data.length) || 0;
    const isItEven = dataLength % 2 === 0;
    switch (true) {
      case index === 0:
      case index === dataLength - 1 && isItEven:
        return "nwc-grid-col-sm-12 ";
      default:
        return "nwc-grid-col-sm-6";
    }
  }
  render() {
    const { data = [] } = this.props;
    return (
      <GridRow className="wc-footerlinks">
        {data.map((item, index) => (
          <GridColumn
            className={`wc-footerlinks-column ${this.getSectionClass(index)}`}
          >
            <div>
              <CustomAnchor
                className="wc-footerlinks-title"
                to={data.url}
                href={data.url}
                target="_self"
              >
                {item.label}
              </CustomAnchor>
            </div>
            <FooterLinkItem data={item.children || []} level={0} />
          </GridColumn>
        ))}
      </GridRow>
    );
  }
}

FooterLinks.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default FooterLinks;
